export default {
  loading: false,
  loaded: false,
  error: '',
  authenticated: false,
  admin: false,
  downloads: [],
  user: {},
  mfa: {}
};
